import { useEffect, useState } from "react";
import { Database, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";

export const SampleDataCard = () => {
  const [st, setSt] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/admin/sample-data").then((r) => setSt(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  if (!st?.available || !window.location.hostname.includes("preview.emergentagent.com")) return null;
  const run = async (method, msg) => {
    setBusy(true);
    try { await api[method]("/admin/sample-data"); toast.success(msg); load(); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="mt-8 max-w-2xl rounded-3xl border border-sky-200 bg-sky-50/60 p-6" data-testid="sample-data-card">
      <div className="flex items-center gap-2 font-display text-lg font-semibold text-sky-900"><Database className="h-5 w-5" />Test data (test app only)</div>
      <p className="mt-1 text-sm text-sky-900/80">Creates 20 sample customers in 4 areas with today's and tomorrow's orders, some deliveries with cash/UPI, pending UTRs, ratings and a referral. This card is hidden on the live app.</p>
      <div className="mt-2 text-sm font-semibold" data-testid="sample-data-count">{st.customers} sample customers loaded</div>
      <div className="mt-4 flex gap-2">
        <Button disabled={busy || st.customers > 0} onClick={() => run("post", "Sample data loaded")} className="rounded-full bg-sky-700 hover:bg-sky-800" data-testid="load-sample-btn">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Load sample data"}</Button>
        <Button disabled={busy || !st.customers} variant="outline" onClick={() => run("delete", "Sample data removed")} className="rounded-full" data-testid="remove-sample-btn">Remove sample data</Button>
      </div>
    </div>
  );
};
